import React from 'react';
import { Button, Spin, Select } from 'antd';
import { hashHistory } from 'react-router'

import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';

import CurrentRoleStore from '../../stores/CurrentRoleStore';
import AttendanceTable from '../share/AttendanceTable';

const Option = Select.Option;

export default class StudentAttendanceStatisticsClassDetailPage extends React.Component {
  constructor(props) {
    super(props);
    let semester = SharedTools.getCurrentSemester(), currentRole = CurrentRoleStore.getCurrentRole();
    let semesters = SharedTools.getAllSemesters(semester, SharedTools.getCurrentSemester(currentRole.created_at));

    this.state = {
      semester,
      currentRole,
      semesters,
      setAttendance: false,
      editAttendance: false,
      visible: false,
      loading: false,
      classId: props.params.classId,
      columns: [],
      students: []
    }

    this.selectSemester = this.selectSemester.bind(this)
    this.callBack = this.callBack.bind(this)

  }

  componentDidMount() {
    this.getClassDetailAttendance(this.state.semester)
  }

  toolTableColumns(month_counts) {
    let columns = [];
    month_counts.map((month) => {
      columns.push({
        title: month.month + '月缺勤次数',
        dataIndex: 'month_' + month.month.toString(),
        render: (text, record) => <span>{record['month_' + month.month] ? record['month_' + month.month] : '-'}</span>
      })
    })

    columns.unshift({ title: '姓名', dataIndex: 'full_name' })
    columns.push({ title: '总计缺勤次数', dataIndex: 'semester_absence' })
    columns.push({ title: '操作', dataIndex: 'operation', render: (text, record) => <span className="header-operation" onClick={this.goNextPage.bind(this, record)}>查看</span> })

    return columns
  }

  getClassDetailAttendance(semester) {
    DataService.getClassStatistic({ class_id: this.state.classId, semester }).then(res => {
      console.log(res)
      let columns = []
      if (res && res.length > 0) {
        columns = this.toolTableColumns(res[0].month_counts)
      }

      let students = [];
      res.forEach(data => {
        let newObj = { id: data.id, full_name: data.full_name, semester_absence: data.semester_absence }, dataObj = {};
        data.month_counts.forEach((month) => {
          dataObj['month_' + month.month] = month.absence_count;
        })
        students.push(Object.assign(newObj, dataObj));
      });
      this.setState({
        students,
        columns
      })
    }, (error) => {
      console.log(error);
      this.setState({
        loading: false,
      })
    })
  }

  callBack(id) {
    hashHistory.push(`student-attendance/schools/${this.props.params.schoolId}/attendance-statistics/classes/${this.props.params.classId}/students/${id}`);
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      })
      this.getClassDetailAttendance(value)
    }
  }

  goNextPage(record) {
    hashHistory.push(`student-attendance/schools/${this.props.params.schoolId}/attendance-statistics/classes/${this.state.classId}/students/${record.id}`);
  }

  render() {
    let { columns, students } = this.state;
    return (
      <div className="student-attendance-statistics-index-page attendance-table-container">
        <div className="page-header">
          学生考勤情况
          <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester} className="select-semester">
            {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
          </Select>
        </div>
        <Spin spinning={this.state.loading}>
          <AttendanceTable columns={columns} data={students} callBack={this.callBack} />
        </Spin>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/attendance/StudentAttendanceStatisticsClassDetailPage.jsx